"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _kycManualActions = require("../../../redux/actions/kycManualActions");
var _kycLevelsSelectors = require("../../../redux/selectors/kycLevelsSelectors");
var _getLevelHelper = require("../../../helpers/getLevelHelper");
var _KYC_ManualIframeComponent = _interopRequireDefault(require("./KYC_ManualIframeComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FORM = 'KYC_Iframe_Form';
var KYCManualIframeForm = (0, _reduxForm.reduxForm)({
  form: FORM
})(_KYC_ManualIframeComponent["default"]);
var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = (0, _kycLevelsSelectors.kycLevelFormSelector)(state),
    verificationLevel = _kycLevelFormSelector.verificationLevel,
    kycConfig = _kycLevelFormSelector.kycConfig,
    alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
    userName = _kycLevelFormSelector.userName,
    email = _kycLevelFormSelector.email,
    processing = _kycLevelFormSelector.processing;
  var level = (0, _getLevelHelper.getDisplayLevel)(kycConfig, verificationLevel + 1);
  return {
    iFrameId: 'apex-iframe',
    level: level,
    formValues: (0, _reduxForm.getFormValues)(FORM)(state),
    processing: processing,
    alphaPointUserID: alphaPointUserID,
    email: email,
    userName: userName,
    currentLevel: verificationLevel
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateField: function updateField(name, val) {
      return dispatch((0, _reduxForm.change)(FORM, name, val));
    },
    registerField: function registerField(field, type) {
      return dispatch((0, _reduxForm.registerField)(FORM, field, type));
    },
    submitInfoManual: function submitInfoManual(setUserConfigForManualKYCPayload) {
      return dispatch((0, _kycManualActions.setUserConfigForManualKYC)(setUserConfigForManualKYCPayload.UserId, setUserConfigForManualKYCPayload.UserName, setUserConfigForManualKYCPayload.underReviewLevel, setUserConfigForManualKYCPayload.Config));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KYCManualIframeForm);